import { render, staticRenderFns } from "./BundleInstance.vue?vue&type=template&id=4a187102"
import script from "./BundleInstance.vue?vue&type=script&lang=js"
export * from "./BundleInstance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports